import { Component, ElementRef, Input } from "@angular/core";
import { NxCheckboxChangeEvent } from "@aposin/ng-aquila/checkbox";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { GenericFieldDirective } from "../../directives/generic-field/generic-field.directive";
import { PrivacyData } from "../../interfaces/forms/privacy-data";
import { FieldService } from "../../services/field/field.service";
import { ModalFormComponent } from "../modal-form/modal-form.component";

@Component({
    selector: "app-privacy-checkbox-form",
    templateUrl: "./privacy-checkbox-form.component.html",
    styleUrls: ["./privacy-checkbox-form.component.scss"],
    standalone: false
})
export class PrivacyCheckboxFormComponent extends GenericFieldDirective {
  @Input() override field!: PrivacyData;

  indeterminate = false;
  checked = false;
  disabled = false;
  showModal = true;

  componentDialogRef!: NxModalRef<ModalFormComponent>;

  constructor(
    public dialogService: NxDialogService,
    protected override fieldService: FieldService,
    protected override element: ElementRef
  ) {
    super(fieldService, element);
  }

  onChange(evt: NxCheckboxChangeEvent) {
    if (evt.checked && this.field.modalValidation) {
      setTimeout(() => {
        this.disabled = true;
        this.checked = false;
        // this.indeterminate = true;
        this.formGroup.get(this.field.name)?.setValue(false);
        this.openModal();
      }, 1);
    }
  }

  openModal() {
    this.componentDialogRef = this.dialogService.open(
      this.field.modalValidationData?.modalComponent ?? ModalFormComponent,
      {
        showCloseIcon: true,
        data: this.field.modalValidationData,
      }
    );

    this.componentDialogRef.afterClosed().subscribe((res: boolean) => {
      this.setCheckboxState(res);
    });
  }

  setCheckboxState(state: boolean = false) {
    this.disabled = false;
    this.indeterminate = false;
    this.formGroup.get(this.field.name)?.setValue(state);
    this.checked = state;
    // this.showModal = !state;
  }
}
